import { render, staticRenderFns } from "./SearchProductCard.vue?vue&type=template&id=2a244086&scoped=true&"
import script from "./SearchProductCard.vue?vue&type=script&lang=js&"
export * from "./SearchProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductCard.vue?vue&type=style&index=0&id=2a244086&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a244086",
  null
  
)

export default component.exports